import { CSSProperties } from 'react';

export const defaultDisplayStyling = {
  '--media-font': 'var(--font-body)',
  '--media-font-weight': 'var(--font-weight-body-sm)',
  '--media-control-background': 'none',
  '--media-text-color': 'var(--player-menu-item-text-color-default)',
} as CSSProperties;

export const defaultButtonStyling = {
  '--media-control-background': 'none',
  '--media-control-hover-background': 'none',
  '--media-secondary-color': 'var(--player-menu-background-default)',
  '--media-text-color': 'var(--player-menu-item-text-color-default)',
  '--media-icon-color': 'var(--player-menu-item-text-color-default)',
} as CSSProperties;

export const defaultRangeStyling = {
  '--media-control-height': 'auto',
  '--media-control-background': 'none',
  '--media-control-hover-background': 'none',
  '--media-range-bar-color': 'var(--player-waveform-foreground-color-default)',
  '--media-range-track-background':
    'var(--player-waveform-background-color-default)',
  '--media-preview-time-background': 'var(--player-menu-background-default)',
  '--media-box-arrow-background': 'var(--player-menu-background-default)',
  '--media-preview-time-text-shadow': 'none',
  '--media-text-color': 'var(--player-menu-item-text-color-default)',
} as CSSProperties;

export const defaultMenuStyling = {
  '--media-secondary-color': 'var(--player-menu-background-default)',
  '--media-text-color': 'var(--player-menu-item-text-color-default)',
  '--media-icon-color': 'var(--player-menu-item-text-color-default)',
  '--media-menu-border-radius': 'var(--player-menu-radius)',
  '--media-menu-item-checked-background':
    'var(--player-menu-item-background-color-selected)',
  '--media-menu-item-hover-background':
    'var(--player-menu-item-background-color-hover)',
} as CSSProperties;
